import { render, staticRenderFns } from "./asoser.vue?vue&type=template&id=5159b3b0&scoped=true&"
import script from "./asoser.vue?vue&type=script&lang=js&"
export * from "./asoser.vue?vue&type=script&lang=js&"
import style0 from "./asoser.vue?vue&type=style&index=0&id=5159b3b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159b3b0",
  null
  
)

export default component.exports